import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { RefreshDashboardModal } from '../components/RefreshDashboardModal';
import { useCallback } from 'react';
import { RefreshDashboardModalProps } from '@modules/dashboard/components/RefreshDashboardModal/RefreshDashboardModal';

export const useShowRefreshDashboardModal = ({
  label,
}: RefreshDashboardModalProps = {}) => {
  const { openModal } = useMuiModalContext();

  return useCallback(
    () =>
      openModal({
        contentComponent: () => <RefreshDashboardModal label={label} />,
        modalProps: {
          shouldDisableBackdropClick: true,
          fullWidth: true,
          maxWidth: 'sm',
          PaperProps: {
            elevation: 3,
          },
        },
      }),
    [openModal, label],
  );
};
